<form [formGroup]="epwUnconnectedRNDForm" (ngSubmit)="onSubmit()">
  <div class="main-box">
    <!-- <div class="header-box d-flex flex-wrap w-100">

      <h2 class="ms-4">
        <span>{{commonLabelConstants.Forms}} &nbsp;</span> / {{labelConstants.EpwCostByProjectHeader}}
           <span mb-2 [ngClass]="{ 'locked-text ms-2 text-danger': isLocked }">{{
          +isLocked ? commonLabelConstants.Locked : ""
        }}</span>
      </h2>
    </div> -->
    <!-- <div class="form-heading">
      <h3>{{labelConstants.EpwCostByProjectHeader}}
        </h3>
    </div> -->
    <div class="claim-table">
        <div class="d-flex p-2 float-end sticky-button">
          <button (click)="exportList()" type="button" class="btn btn-primary-datalist ms-3" *ngIf="contractor.controls.length != 0">
            <i class="fa-solid fa-download"></i>
            <span class="hidebuttonName"> EXPORT</span>
          </button>
        </div>
        <div class="table-container">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="equal-width-col">{{labelConstants.ContractorName}}</th>
                  <th class="equal-width-col">{{labelConstants.JobRole}}</th>
                  <th class="equal-width-col"> {{ labelConstants.CostForUKWork }} </th>
                  <th class="equal-width-col"> {{ labelConstants.CostForNonUKWork }} </th>
                  <th class="equal-width-col" *ngFor="let item of projectList">
                    {{ item.projectName }}
                  </th>
                  <th class="equal-width-col">{{labelConstants.TotalQualifyingCostsUK}}</th>
                  <th class="equal-width-col"> {{ labelConstants.TotalQualifyingCostsNonUK }} </th>
                </tr>
              </thead>
              <tbody>
                <ng-container formArrayName="contractor">
                  <tr *ngFor="let item of contractor.controls; let i = index" [formGroupName]="i">
                    <td class="equal-width-col">
                      <span>{{ item.get("contractorName")?.value }}</span>
                    </td>

                    <td class="equal-width-col">
                      <span>{{ item.get("jobRole")?.value }}</span>
                    </td>
                    <td class="equal-width-col">
                      <span>{{ item.get("paymentsMadeToTheStaffProviderForUKWork")?.value | customCurrency:
                        env.CurrencyFormat }}</span>
                    </td>
                    <td class="equal-width-col">
                      <span>{{ item.get("paymentsMadeToTheStaffProviderForNonUKWork")?.value | customCurrency:
                        env.CurrencyFormat }}</span>
                    </td>
                    <ng-container formArrayName="projects">
                      <td class="equal-width-col" *ngFor="
                          let itemDetails of getProjectDetails(i).controls;
                          let j = index
                        " [formGroupName]="j">
                        <span>{{ itemDetails.get("rndEligibility")?.value | customPercentage:
                          env.CurrencyFormat}}</span>
                      </td>
                      <td>
                        <span>{{ item.get("totalEligibilityAmountForUKWork")?.value | customCurrency: env.CurrencyFormat
                          }}</span>
                      </td>
                      <td>
                        <span>{{ item.get("totalEligibilityAmountForNonUKWork")?.value | customCurrency:
                          env.CurrencyFormat }}</span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
              <tfoot *ngIf="contractor.controls && contractor.controls.length > 0; else noRecords">
                <tr>
                  <td colspan="2"><b>{{labelConstants.ExternallyProviderWorker}} (£)</b></td>
                  <td class="equal-width-col">
                    <span><b>{{ getCostTotal() | customCurrency: env.CurrencyFormat}}</b></span>
                  </td>
                  <td class="equal-width-col">
                    <span><b>{{ getCostTotal1() | customCurrency: env.CurrencyFormat}}</b></span>
                  </td>
                  <td class="equal-width-col" *ngFor="let item of projectList; let projectIndex = index">
                    <span><b>{{ getTotalProduct(projectIndex) }}</b></span>
                  </td>
                  <td>
                    <span><b>{{ getTotalQualifyingCosts() | customCurrency: env.CurrencyFormat }}</b></span>
                  </td>
                  <td>
                    <span><b>{{ getTotalQualifyingCosts1() | customCurrency: env.CurrencyFormat }}</b></span>
                  </td>
                </tr>
              </tfoot>
              <ng-template #noRecords>
                <tfoot>
                  <tr>
                    <td [colSpan]="6+projectList.length" class="text-center">{{commonLabelConstants.NoReacordFound}}
                    </td>
                  </tr>
                </tfoot>
              </ng-template>
            </table>
          </div>
        </div>
      </div>
    </div>
</form>
